<script setup lang="ts">
import {
  Contexts,
  getContainer,
  NamedBindings,
  TranslationService,
} from '@dandelion/core';
import { UserService } from '../services/UserService';

const params = new URLSearchParams(window.location.search);
const jwtToken = params.get('jwt');

window.localStorage.setItem('jwtToken', jwtToken!);

const container = getContainer(Contexts.SHARED);
const userService = container.get(NamedBindings.UserService) as UserService;
const ts = container.get(
  NamedBindings.TranslationService
) as TranslationService;
userService.setIsLogged(true);

//TODO change so that we don't need to refresh the page to actually get the user in page
window.location.href = '/';
</script>

<template>
  <span class="redirecting-msg" v-html="`${ts.t('Redirecting...')}`"></span>
</template>
